import { Button, Modal, Stack } from "@mantine/core";
import classNames from "classnames";
import { ModalFooter } from "../../mantine/components/ModalFooter/ModalFooter";

interface SiteStatusModalProps {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  header: string;
  children: React.ReactNode;
}

function SiteStatusModal({
  className,
  isOpen,
  onClose,
  header,
  children
}: SiteStatusModalProps) {
  return (
    <Modal
      className={classNames("SiteStatusModal", className)}
      opened={isOpen}
      title={header}
      onClose={onClose}
    >
      <Stack>{children}</Stack>

      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          Schließen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { SiteStatusModal };
